// Little Catio buy box (Shopify port of cat-pod-store/app.js).
// Reads #CatioData (gallery, the options matched to variants, gift) written by sections/catio-product.liquid.
// Adds to the cart through window.CatioCart (assets/catio-cart.js), which opens the slide-out cart.
(function () {
  let pdp = null; // the buy box on this page (rebuilt when the theme editor re-renders the section)
  function initPDP() {
  const dataEl = document.getElementById('CatioData');
  if (!dataEl) return null;
  const D = JSON.parse(dataEl.textContent);
  const $ = id => document.getElementById(id);
  const money = c => (D.moneyFormat || '£{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2)).replace(/<[^>]*>/g, '');
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Phones never split "carry bag", "+ free catnip" or "Twin Set" across lines, nor "7-day" as "7-" / "day" (as on the static page).
  const nbsp = t => String(t || '').replace(/ /g, '\u00A0');
  const keepParts = t => String(t || '').split(' + ').map(nbsp).join(' +\u00A0');
  const joinHyphens = t => String(t || '').replace(/(\d)-(?=[a-z])/gi, '$1-\u2060');
  const calm = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- gallery: one-row thumbs, arrows, swipe, crossfade; autoplay every 5s ----------
     The in-action video plays until it ends (8s at most) before moving on. Autoplay pauses while the gallery is off screen,
     the tab is hidden, the mouse is over it (desktop), it has keyboard focus or a finger is on it. Any arrow, thumbnail,
     swipe or key restarts the 5s wait, so it never fights the shopper. No autoplay with prefers-reduced-motion.
     Only the next slide is preloaded. */
  const thumbs = $('thumbs'), mainImg = $('mainImg'), mainVid = $('mainVid'), stage = $('catioStage');
  const M = D.media || [];
  const small = window.innerWidth * (window.devicePixelRatio || 1) <= 1300;
  const pick = m => (small && m.srcM) ? m.srcM : m.src;
  const AUTO_MS = 5000, VIDEO_MAX_MS = 8000, FADE_MS = 500;
  const autoplay = M.length > 1 && !calm();
  const cleanup = [];
  let gIdx = 0, swapToken = 0, timer = null;
  const hold = { offscreen: true, hidden: document.hidden, hover: false, focus: false, touch: false };
  const running = () => autoplay && !hold.offscreen && !hold.hidden && !hold.hover && !hold.focus && !hold.touch;
  const stopTimer = () => { if (timer) { clearTimeout(timer); timer = null; } };
  function schedule() {
    stopTimer();
    if (!running()) return;
    const m = M[gIdx];
    timer = setTimeout(() => { timer = null; if (running()) showSlide(gIdx + 1); }, m && m.type === 'video' ? VIDEO_MAX_MS : AUTO_MS);
  }
  const dropOverlays = () => stage.querySelectorAll('.g-fade').forEach(n => n.remove());
  // The new image fades in over the current one (image or video), then becomes the base image.
  function crossfadeTo(src, alt) {
    const t = ++swapToken;
    const im = new Image(); im.decoding = 'async'; im.src = src;
    const ready = im.decode ? im.decode().catch(() => {}) : Promise.resolve();
    ready.then(() => {
      if (t !== swapToken) return;
      const settle = ov => {
        if (t !== swapToken) return;
        mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.alt = alt || ''; mainImg.hidden = false;
        mainVid.classList.remove('is-on'); mainVid.pause();
        const done = () => { if (t !== swapToken) return; if (ov) ov.remove(); mainVid.hidden = true; };
        (mainImg.decode ? mainImg.decode().catch(() => {}) : Promise.resolve()).then(done);
      };
      if (calm()) { dropOverlays(); settle(null); return; }
      dropOverlays();
      im.className = 'g-fade'; im.alt = ''; im.setAttribute('aria-hidden', 'true');
      stage.appendChild(im);
      void im.offsetWidth; // start the transition from opacity 0
      im.classList.add('is-in');
      setTimeout(() => settle(im), FADE_MS + 20);
    });
  }
  function showVideo(m) {
    ++swapToken;
    dropOverlays();
    mainVid.hidden = false; mainVid.muted = true;
    if (mainVid.dataset.src !== m.src) { mainVid.dataset.src = m.src; mainVid.poster = m.poster || ''; mainVid.src = m.src; }
    else { try { mainVid.currentTime = 0; } catch (e) {} }
    mainVid.setAttribute('aria-label', m.alt || '');
    requestAnimationFrame(() => mainVid.classList.add('is-on')); // fades in over the image underneath
    mainVid.play().catch(() => {});
  }
  // Warm only the slide after this one, so autoplay never pulls every large image up front.
  function preloadNext() {
    const n = M[(gIdx + 1) % M.length];
    if (n && n.type !== 'video') { const im = new Image(); im.decoding = 'async'; im.src = pick(n); }
  }
  function showSlide(i) {
    if (!M.length) return;
    gIdx = (i + M.length) % M.length;
    const m = M[gIdx];
    if (m.type === 'video') showVideo(m); else crossfadeTo(pick(m), m.alt);
    const btns = thumbs.querySelectorAll('button');
    btns.forEach((x, n) => { x.classList.toggle('active', n === gIdx); x.setAttribute('aria-current', n === gIdx ? 'true' : 'false'); });
    const b = btns[gIdx];
    if (b) thumbs.scrollTo({ left: b.offsetLeft - (thumbs.clientWidth - b.clientWidth) / 2, behavior: calm() ? 'auto' : 'smooth' });
    preloadNext();
    schedule(); // every change (manual or automatic) restarts the wait
  }
  const on = (el, type, fn, opt) => { el.addEventListener(type, fn, opt); cleanup.push(() => el.removeEventListener(type, fn, opt)); };
  if (thumbs && mainImg && mainVid && stage) {
    if (M[0] && M[0].type === 'video') { mainVid.dataset.src = M[0].src; mainVid.classList.add('is-on'); }
    // While autoplay runs, the video plays once and the gallery moves on when it ends; with autoplay off it loops.
    mainVid.loop = !autoplay;
    on(mainVid, 'ended', () => {
      if (!M[gIdx] || M[gIdx].type !== 'video') return;
      if (running()) showSlide(gIdx + 1); else mainVid.play().catch(() => {}); // held: keep it playing
    });
    thumbs.querySelectorAll('button').forEach((b, i) => { b.onclick = () => showSlide(i); });
    $('gPrev').onclick = () => showSlide(gIdx - 1);
    $('gNext').onclick = () => showSlide(gIdx + 1);
    // swipe: autoplay holds from the first touch until the finger lifts, so a swipe is never interrupted
    let touchX = null, touchY = null;
    on(stage, 'touchstart', e => { touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; hold.touch = true; stopTimer(); }, { passive: true });
    const endTouch = e => {
      hold.touch = false;
      if (touchX !== null && e.changedTouches && e.changedTouches[0]) {
        const dx = e.changedTouches[0].clientX - touchX, dy = e.changedTouches[0].clientY - touchY;
        touchX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { showSlide(gIdx + (dx < 0 ? 1 : -1)); return; }
      }
      touchX = null;
      schedule();
    };
    on(stage, 'touchend', endTouch);
    on(stage, 'touchcancel', endTouch);
    on(stage, 'keydown', e => {
      if (e.key === 'ArrowLeft') showSlide(gIdx - 1);
      if (e.key === 'ArrowRight') showSlide(gIdx + 1);
    });
    // pause on hover (mouse devices only) and while the gallery holds keyboard focus
    const gallery = stage.closest('.gallery') || stage;
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      on(gallery, 'mouseenter', () => { hold.hover = true; stopTimer(); });
      on(gallery, 'mouseleave', () => { hold.hover = false; schedule(); });
    }
    // keyboard focus only (a mouse click on an arrow focuses it too, and that must not stop autoplay)
    on(gallery, 'focusin', e => { if (e.target.matches && e.target.matches(':focus-visible')) { hold.focus = true; stopTimer(); } });
    on(gallery, 'focusout', e => { if (!gallery.contains(e.relatedTarget)) { hold.focus = false; schedule(); } });
    // pause while off screen or in a hidden tab (and rest the video)
    const vis = () => {
      hold.hidden = document.hidden;
      if (hold.hidden) { stopTimer(); return; }
      schedule();
    };
    on(document, 'visibilitychange', vis);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => {
        hold.offscreen = !es[es.length - 1].isIntersecting;
        if (hold.offscreen) { stopTimer(); if (M[gIdx] && M[gIdx].type === 'video') mainVid.pause(); }
        else { if (M[gIdx] && M[gIdx].type === 'video') mainVid.play().catch(() => {}); schedule(); }
      }, { threshold: 0.35 });
      io.observe(stage);
      cleanup.push(() => io.disconnect());
    } else { hold.offscreen = false; schedule(); }
    // only the second slide is warmed at first, once the page has loaded
    const warm = () => setTimeout(preloadNext, 400);
    if (document.readyState === 'complete') warm(); else on(window, 'load', warm);
  }
  cleanup.push(stopTimer);
  const destroyGallery = () => cleanup.splice(0).forEach(fn => { try { fn(); } catch (e) {} });

  /* ---------- options: built once from the variants; update() only moves the selection ---------- */
  const O = D.options || [];
  const FREE_MIN = Number(D.freeMin) || 0, SHIP = Number(D.ship) || 0;
  // Free tracked UK delivery on every order (Theme settings → Little Catio); the threshold only applies when that is off.
  const shipsFree = o => !!D.freeAll || (FREE_MIN > 0 && o.price >= FREE_MIN);
  const saving = o => Math.max(0, o.was - o.price);
  const withSaving = (t, o) => String(t || '').replace(/\[saving\]/g, money(saving(o)));
  const firstFree = O.find(shipsFree);
  /* ---------- colours (Set / Colour variants). C = the colours the product really has; empty while it has no Colour option,
     and then everything works exactly as before (one variant per option card). ---------- */
  const lc = t => String(t || '').toLowerCase();
  const C = (D.colours || []).filter(c => O.some(o => (o.variants || []).some(v => lc(v.colour) === lc(c.name))));
  O.forEach(o => { o.baseImg = o.img; });
  const fromUrl = D.urlVariant ? O.map(o => ({ o, v: (o.variants || []).find(v => v.id === D.urlVariant) })).find(x => x.v) : null;
  let colour = fromUrl && fromUrl.v.colour ? fromUrl.v.colour : (C[0] ? C[0].name : null);
  const colourObj = col => C.find(c => lc(c.name) === lc(col)) || null;
  const variantFor = (o, col) => { const vs = o.variants || []; return (col && vs.find(v => lc(v.colour) === lc(col))) || vs[0] || null; };
  // Point every option card at the chosen colour's variant (id, price, stock, image).
  function applyColour() {
    const co = colourObj(colour);
    O.forEach(o => {
      const v = variantFor(o, colour);
      if (v) { o.variantId = v.id; o.available = v.available; o.price = v.price; o.was = v.was; o.colour = v.colour; }
      o.img = (co && co.card) || (v && lc(v.colour) === lc(colour) && v.img) || (co && co.hero && co.hero.thumb) || o.baseImg;
    });
  }
  applyColour();
  let current = (fromUrl && fromUrl.o) || O.find(o => o.selected) || O[0];
  const bundlesEl = $('bundles');
  const coloursEl = $('colours');
  // The slide marked "colour hero" shows the chosen colour's photo (theme image from the colour block, else the variant's image).
  const heroIdx = M.findIndex(m => m.colourHero);
  const heroBase = heroIdx >= 0 ? { src: M[heroIdx].src, srcM: M[heroIdx].srcM, alt: M[heroIdx].alt, thumb: ((thumbs && thumbs.querySelectorAll('button img')[heroIdx]) || {}).src } : null;
  function heroFor(col) {
    const co = colourObj(col);
    if (co && co.hero) return Object.assign({ alt: co.alt }, co.hero);
    const v = O[0] && variantFor(O[0], col);
    return (v && lc(v.colour) === lc(col) && v.hero) || null;
  }
  function applyHero(show) {
    if (heroIdx < 0 || !thumbs) return;
    const h = (colour && heroFor(colour)) || heroBase;
    if (!h) return;
    const m = M[heroIdx], changed = m.src !== h.src;
    m.src = h.src; m.srcM = h.srcM || h.src;
    if (h.alt) m.alt = h.alt;
    const tb = thumbs.querySelectorAll('button')[heroIdx], ti = tb && tb.querySelector('img');
    if (ti && h.thumb) ti.src = h.thumb;
    if (tb && h.alt) tb.setAttribute('aria-label', `Show image ${heroIdx + 1}: ${h.alt}`);
    if (changed && (show || gIdx === heroIdx)) showSlide(heroIdx);
  }
  function pickColour(col) {
    if (!col || lc(col) === lc(colour)) return;
    colour = col; applyColour(); renderCards(); update(); applyHero(true);
  }
  if (coloursEl) {
    const sws = () => [...coloursEl.querySelectorAll('.swatch')];
    sws().forEach(b => b.addEventListener('click', () => pickColour(b.dataset.colour)));
    // warm the colour's hero photo as soon as a swatch is pointed at, focused or touched, so the swap is quick
    const warmed = new Set();
    const warm = col => { if (warmed.has(col)) return; warmed.add(col); const h = heroFor(col); if (h) { const im = new Image(); im.src = pick(h); } };
    sws().forEach(b => ['pointerenter', 'focus', 'touchstart'].forEach(t => b.addEventListener(t, () => warm(b.dataset.colour), { passive: true })));
    coloursEl.addEventListener('keydown', e => {
      if (!/^Arrow(Up|Down|Left|Right)$/.test(e.key)) return;
      e.preventDefault();
      const list = sws(), i = list.findIndex(b => lc(b.dataset.colour) === lc(colour)), n = /Up|Left/.test(e.key) ? i - 1 : i + 1;
      const b = list[(n + list.length) % list.length]; pickColour(b.dataset.colour); b.focus();
    });
  }

  function renderCards() {
    if (!bundlesEl) return;
    bundlesEl.querySelectorAll('.bundle').forEach((el, i) => {
      const o = O[i]; if (!o) { el.remove(); return; }
      const save = o.was - o.price;
      const flag = o.flag || (save > 0 && D.saveFlag ? withSaving(D.saveFlag, o) : '') || (!D.freeAll && shipsFree(o) ? D.freeFlag : '');
      el.innerHTML = `
        ${flag ? `<span class="flag">${esc(flag)}</span>` : ''}
        <div class="b-top">
          <div class="b-main">
            <div class="b-name">${esc(o.title)}</div>
            ${save > 0 ? `<div class="b-save">You save ${money(save)}${o.saveNote ? ' ' + esc(nbsp(o.saveNote)) : ''}</div>` : ''}
            ${o.contents ? `<div class="b-contents">${esc(keepParts(o.contents))}${o.variantId && !o.available ? ' · Sold out' : ''}</div>` : ''}
          </div>
          <div class="b-price">${money(o.price)}${save > 0 ? `<span class="was">${money(o.was)}</span>` : ''}</div>
          <img class="b-img" src="${esc(o.img)}" alt="" width="60" height="60">
        </div>`;
      el.classList.toggle('sold-out', !!o.variantId && !o.available);
      el.onclick = () => { current = o; update(); };
    });
    // arrow keys move between the options (radio group)
    if (bundlesEl.dataset.keys) return;
    bundlesEl.dataset.keys = '1';
    bundlesEl.addEventListener('keydown', e => {
      if (!/^Arrow(Up|Down|Left|Right)$/.test(e.key)) return;
      e.preventDefault();
      const i = O.indexOf(current), n = /Up|Left/.test(e.key) ? i - 1 : i + 1;
      current = O[(n + O.length) % O.length]; update();
      bundlesEl.querySelector('.bundle.active').focus();
    });
  }

  // The lines under the free gift card: the guide is always on; free delivery unlocks on options over the threshold.
  function renderKit() {
    const kit = $('kit'); if (!kit) return;
    const rows = [];
    if (D.guideName) rows.push({ on: true, name: D.guideName, line: D.guideLine || '' });
    if (D.shipName && D.freeAll) {
      rows.push({ on: true, name: D.shipName, line: D.shipLineAll || '' });
    } else if (D.shipName && firstFree) {
      const on = shipsFree(current);
      rows.push({ on, name: D.shipName, line: on ? `Unlocked with the ${nbsp(current.name)}` : `Unlock with the ${nbsp(firstFree.name)}${SHIP ? ` (${nbsp(money(SHIP) + ' on ' + current.name)})` : ''}` });
    }
    kit.innerHTML = rows.map(r => `<div class="kcell ${r.on ? 'on' : 'off'}"><span class="kchk" aria-hidden="true">${r.on ? '✓' : '+'}</span><div><b>${esc(r.name)}</b><span>${esc(r.line)}</span></div></div>`).join('');
    kit.hidden = !rows.length;
  }

  function update() {
    if (!current) return;
    if (bundlesEl) bundlesEl.querySelectorAll('.bundle').forEach((el, i) => {
      const on = O[i] === current;
      el.classList.toggle('active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.tabIndex = on ? 0 : -1;
    });
    renderKit();
    if (coloursEl) {
      if ($('colourName')) $('colourName').textContent = colour || '';
      coloursEl.querySelectorAll('.swatch').forEach(b => {
        const on = lc(b.dataset.colour) === lc(colour);
        b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        const v = variantFor(current, b.dataset.colour);
        const out = !v || lc(v.colour) !== lc(b.dataset.colour) || !v.available;
        b.classList.toggle('is-out', out);
        b.setAttribute('aria-label', b.dataset.colour + (out ? ' (sold out)' : ''));
      });
    }
    const price = money(current.price);
    if ($('bundleName')) $('bundleName').textContent = current.name;
    // every "Add to cart – £46.99" on the page (buy box, buttons down the page, sticky bar) follows the choice
    document.querySelectorAll('[data-catio-price]').forEach(el => { el.textContent = price; });
    if ($('stickyPrice')) $('stickyPrice').textContent = price;
    if ($('stickyName')) $('stickyName').textContent = current.name + (C.length && colour ? ' · ' + colour : ''); // short name: "Twin Set (2 cats)" gets cut off at 375px
    if ($('stickyImg')) $('stickyImg').src = current.img;
    if ($('stickySub')) $('stickySub').textContent = withSaving(current.sticky, current);
    if ($('boxContents')) $('boxContents').textContent = joinHyphens(current.box || '');
    const ok = !!current.variantId && current.available;
    const soldOut = !!current.variantId && !current.available;
    $('addToCart').disabled = soldOut;
    if ($('stickyCta')) $('stickyCta').disabled = soldOut;
    document.querySelectorAll('[data-catio-buy]').forEach(b => { b.disabled = soldOut && D.ctaAction !== 'scroll'; });
    hideError();
    return ok;
  }

  /* ---------- add to cart ---------- */
  const errEl = $('catioError');
  function hideError() { if (errEl) errEl.hidden = true; }
  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg; errEl.hidden = false;
  }
  let adding = false;
  async function addCurrent(btn) {
    if (adding || !current) return;
    if (!current.variantId) { jumpToOptions(); showError("Sorry, this option isn't available to buy yet."); return; }
    if (!current.available) { showError('Sorry, this option is sold out right now.'); return; }
    adding = true; hideError();
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    try {
      if (window.CatioCart && window.CatioCart.add) {
        await window.CatioCart.add(current.variantId, 1);
      } else {
        const r = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: current.variantId, quantity: 1 }] }),
        });
        if (!r.ok) throw new Error(await r.text());
        location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (e) {
      console.error(e);
      let msg = 'Sorry, something went wrong adding to your cart. Please try again.';
      try { const j = JSON.parse(e.message); if (j && j.description) msg = j.description; } catch (x) {}
      jumpToOptions(); showError(msg);
    } finally {
      adding = false;
      if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); }
    }
  }
  function jumpToOptions() {
    if (!bundlesEl) return;
    const r = bundlesEl.getBoundingClientRect();
    if (r.top < 0 || r.bottom > innerHeight) bundlesEl.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' });
    const a = bundlesEl.querySelector('.bundle.active');
    if (a) a.focus({ preventScroll: true });
  }

  $('addToCart').addEventListener('click', e => addCurrent(e.currentTarget));
  if ($('stickyCta')) $('stickyCta').addEventListener('click', e => addCurrent(e.currentTarget));
  document.querySelectorAll('[data-catio-jump]').forEach(b => b.addEventListener('click', jumpToOptions));

  /* ---------- sticky bar on phones once the main button scrolls away ---------- */
  const sticky = $('sticky'), mainCta = $('addToCart');
  // scroll check (an IntersectionObserver misses jumps past the button, e.g. anchor links)
  const syncSticky = () => { if (sticky && mainCta) sticky.classList.toggle('show', mainCta.getBoundingClientRect().bottom < 0); };

  // Desktop: the gallery sticks beside the buy box only when all of it (main image + thumbnails) fits under the header;
  // on shorter laptop screens it scrolls with the page, so the thumbnails are never cut off.
  const gal = stage ? stage.closest('.gallery') : null;
  const fitGallery = () => {
    if (!gal) return;
    const desktop = matchMedia('(min-width: 901px)').matches;
    gal.style.position = desktop && gal.offsetHeight + 120 > innerHeight ? 'static' : '';
  };

  renderCards();
  update();
  applyHero(false);
  syncSticky();
  fitGallery();
  window.CatioPDP = { get current() { return current; }, get colour() { return colour; }, colours: C, add: () => addCurrent(), options: O };
  return { D, addCurrent, jumpToOptions, syncSticky, fitGallery, destroy: destroyGallery };
  }

  pdp = initPDP();
  // Buttons down the page: add the chosen option (default) or go back up to the options (Theme settings → Little Catio).
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-catio-buy]');
    if (!b || !pdp) return;
    e.preventDefault();
    const mode = b.dataset.catioBuy || pdp.D.ctaAction;
    if (mode === 'scroll') pdp.jumpToOptions(); else pdp.addCurrent(b);
  });
  addEventListener('scroll', () => { if (pdp) pdp.syncSticky(); }, { passive: true });
  addEventListener('resize', () => { if (pdp) pdp.fitGallery(); });
  addEventListener('load', () => { if (pdp) pdp.fitGallery(); });
  // Theme editor: rebuild the buy box when its section is re-rendered after a settings change.
  document.addEventListener('shopify:section:load', e => { if (e.target.querySelector('#CatioData')) { if (pdp && pdp.destroy) pdp.destroy(); pdp = initPDP(); } });
})();

/* ---------- section loops (how it works, routines): load and play only while on screen ---------- */
(function () {
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(e => {
    const v = e.target;
    if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); } else v.pause();
  }), { threshold: 0.25 }) : null;
  const watch = root => root.querySelectorAll('.lc video.loop, video.loop').forEach(v => {
    if (io) io.observe(v); else { v.preload = 'auto'; v.play().catch(() => {}); }
  });
  watch(document);
  document.addEventListener('shopify:section:load', e => watch(e.target));
})();
